import { render, staticRenderFns } from "./CalendarDate.vue?vue&type=template&id=65641244&scoped=true"
import script from "./CalendarDate.vue?vue&type=script&lang=js"
export * from "./CalendarDate.vue?vue&type=script&lang=js"
import style0 from "./CalendarDate.vue?vue&type=style&index=0&id=65641244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65641244",
  null
  
)

export default component.exports